import styled from 'styled-components';

export const PoweredByCW = styled.img`
  height: 18px;
  width: 200px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  margin-bottom: 10px;
`;

export const PoweredByCWLoginPage = styled.img`
  display: block;
  height: 18px;
  width: 200px;
  margin: 0 auto;
  margin-bottom: 25px;
`;
